import Vue from "vue"
import Vuex from "vuex"
import Cookies from "js-cookie"
import { getNavMenu } from "@/api/new-question-iteration/home";
import { getPersonRoute } from "@/api/new-question-iteration/common"
import { userIsBindingOrg } from "@/api/user"
import { setFavicon } from "@/router";
import { HOME_PAGE_MAP } from "@/utils/platform-config"
Vue.use(Vuex)

const TOKEN_KEY = "TOKEN_USER"
const USER_INFO = "USER_INFO"
const CURRENT_ID = "CURRENT_ID"
const CURRENT_Name = "CURRENT_Name"

export default new Vuex.Store({
    state: {
        isCheckEnd: true, // false 正处于检查 true 检查结束
        // 一个对象，存储当前登录用户信息（token等数据）
        user: Cookies.get(TOKEN_KEY) || null,
        userInfo: JSON.parse(Cookies.get(USER_INFO) || null),
        currentClassId: JSON.parse(window.sessionStorage.getItem(CURRENT_ID)),
        currentClassName: JSON.parse(window.sessionStorage.getItem(CURRENT_Name)),
        recruitScrollY: 0,
        platform: "",
        navMenu: [],
        profileRoutes: [],
        isLoadNavMenu: false, // 是否加载过导航栏
        isLoadProfileRoutes: false,
        isLoadBingIp: false,
        isBindingIp: false, // 是否绑定ip
        questionnaireDetail: {}, // 问卷详情
        groupInfo: {}, // 机构信息
        protocol: window.location.protocol
    },
    getters: {
        recruitScrollY: state => state.recruitScrollY,
        // 允许的平台
        availablePlatform: state => {
            return (platforms) => {
                return Array.isArray(platforms) ? platforms.includes(state.platform) : false
            }
        },
        isLogin: state => String(state.user) !== "null" && state.user
    },
    mutations: {
        setUser(state, data) {
            state.user = data
            if (data == null) {
                state.userInfo = null;
                Cookies.remove(TOKEN_KEY)
                Cookies.remove(USER_INFO)
                localStorage.removeItem("user_modular")
                return
            }
            Cookies.set(TOKEN_KEY, state.user)
        },
        logout(state) {
            state.user = null;
            state.userInfo = null;
            Cookies.remove(TOKEN_KEY)
            Cookies.remove(USER_INFO)
            localStorage.removeItem("user_modular")
        },
        setUserInfo(state, data) {
            if (data == null) {
                state.userInfo = data
                Cookies.remove(USER_INFO)
                return
            }
            const platformMap = HOME_PAGE_MAP[state.platform]
            if (platformMap) {
                data.PlatformName = platformMap.title
            }
            state.userInfo = data
            state.userInfo.Logo = data.GroupUserLogo || data.Logo
            // 是否是机构管理员
            const role = state.userInfo.Role
            state.userInfo.isOrgManager = role === "1" || role === "" || role === "Admin" || role == null
            Cookies.set(USER_INFO, JSON.stringify(state.userInfo))
            setFavicon(state.userInfo.Logo)
        },
        setCurrentClassId(state, data) {
            state.currentClassId = data
            window.sessionStorage.setItem(CURRENT_ID, JSON.stringify(state.currentClassId))
        },
        setCurrentClassName(state, data) {
            state.currentClassName = data
            window.sessionStorage.setItem(CURRENT_Name, JSON.stringify(state.currentClassName))
        },
        changeRecruitScrollY(state, recruitScrollY) {
            state.recruitScrollY = recruitScrollY
        },
        // 设置平台
        setPlatform(state, payload) {
            state.platform = payload
        },
        // 设置导航
        setNavMenu(state, navMenu) {
            state.navMenu = navMenu
            state.isLoadNavMenu = true
        },
        setPersonCenter(state, personRoutes) {
            state.profileRoutes = personRoutes
            state.isLoadProfileRoutes = true
        },
        clearPersonCenter(state) {
            state.profileRoutes = []
            state.isLoadProfileRoutes = false
        },
        clearNavMenu(state) {
            state.navMenu = []
            state.isLoadNavMenu = false
        },
        setLoadBindingIp(state) {
            state.isLoadBingIp = true
        },
        setBindingIp (state, payload) {
            state.isBindingIp = payload
        },
        setQuestionnaireDetail (state, payload) {
            state.questionnaireDetail = payload || {}
        },
        // 设置机构信息
        setGroupInfo (state, payload) {
            state.groupInfo = payload
        }
    },
    actions: {
        /**
         * 获取导航栏菜单
         * @return {Promise<unknown>}
         **/
        getNavMenu({ commit, state }) {
            return new Promise((resolve, reject) => {
                // 根据id映射路径和是否需要登录
                const pathAndIsLoginMapById = Object.freeze({
                    "-100": ["/question/public", state.platform === "yixue" ? !state.isBindingIp : true],
                    "-200": ["/exam", true],
                    "-300": ["/course", true],
                    "-400": ["/psq", true],
                    "-500": ["/home-medicine", false]
                })
                getNavMenu().then(res => {
                    const navMenu = (res.data || []).map(item => Object.assign(item, {
                        Path: pathAndIsLoginMapById[item.Code][0],
                        IsNeedLogin: pathAndIsLoginMapById[item.Code][1]
                    }))
                    resolve(navMenu)
                    commit("setNavMenu", navMenu)
                }).catch(e => {
                    commit("setNavMenu", [])
                    reject(e)
                })
            })
        },
        // 获取个人中心菜单
        getPersonCenter({ commit }) {
            return new Promise((resolve, reject) => {
                getPersonRoute().then(res => {
                    commit("setPersonCenter", res)
                    resolve(res)
                }).catch(e => {
                    commit("setPersonCenter", [])
                    reject(e)
                })
            })
        },
        // 设置绑定ip
        async setBindingIp({ commit }) {
            try {
                const res = await userIsBindingOrg()
                commit("setLoadBindingIp")
                commit("setBindingIp", res.IsIPAuthorize)
                commit("setGroupInfo", res)
                return res
            } catch (e) {
                commit("setLoadBindingIp")
                commit("setBindingIp", false)
                return Promise.reject()
            }
        }
    },
    modules: {}
})
